var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-groups"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups",
    clipPath: "url(#clip-groups)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-people",
    "data-name": "Icon material-people",
    d: "M333.545,145.319c36.746,0,66.188-30.78,66.188-68.91S370.292,7.5,333.545,7.5s-66.409,30.78-66.409,68.91S296.8,145.319,333.545,145.319Zm-177.091,0c36.746,0,66.188-30.78,66.188-68.91S193.2,7.5,156.455,7.5,90.045,38.28,90.045,76.41,119.708,145.319,156.455,145.319Zm0,45.94C104.877,191.259,1.5,218.134,1.5,271.653v57.425H311.409V271.653C311.409,218.134,208.032,191.259,156.455,191.259Zm177.091,0c-6.42,0-13.725.459-21.472,1.148,25.678,19.295,43.609,45.251,43.609,79.246v57.425H488.5V271.653C488.5,218.134,385.123,191.259,333.545,191.259Z",
    transform: "translate(11 87.711)",
    fill: "#2c9c55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.53e2d289.svg";
export { ForwardRef as ReactComponent };